import {PractitionerType} from "@/shared/domain/Practitioner";
import _ from "lodash";
import {
    CompetitionHorsePractitioner,
    CompetitionIndividualCombination,
    CompetitionPractitioner,
    CompetitionTeamPractitioner
} from "@/shared/domain/CompetitionPractitioner";


export const useCompetitionPractitionerSearchHelper = () => {
    function search<I>(list: Array<I>, filter: string, extractor: (input: I) => CompetitionPractitioner | undefined = (i) => i as CompetitionPractitioner): Array<I> {
        return list.filter(it => {
            const p = extractor(it)
            return p ? matches(filter, p) : true
        })
    }

    function matches(filter: string, input: CompetitionPractitioner): boolean {
        if (!filter || filter === '') {
            return true;
        } else {
            return extractTexts(input)
                .map(field => textMatches(field, filter))
                .reduce((shouldInclude, include) => include || shouldInclude, false)
        }
    }

    function textMatches(text: string, filter: string) {
        if (!text) {
            return false;
        }
        const f = _.deburr(_.lowerCase(_.trim(filter)))
        const t = _.deburr(_.lowerCase(_.trim(text)))
        return t.includes(f)
    }

    function extractTexts(practitioner: CompetitionPractitioner): Array<string> {
        switch (practitioner.type) {
            case PractitionerType.INDIVIDUAL:
                return extractIndividualCombination(practitioner as CompetitionIndividualCombination)
            case PractitionerType.HORSE:
                return extractHorse(practitioner as CompetitionHorsePractitioner)
            case PractitionerType.TEAM:
                return extractTeam(practitioner as CompetitionTeamPractitioner)
            default:
                return []
        }
    }

    function extractIndividualCombination(practitioner: CompetitionIndividualCombination): Array<string> {
        const terms = [practitioner.rider.name, practitioner.horse.name]
        if (practitioner.organisation) {
            terms.push(practitioner.organisation.name)
        }
        return terms
    }

    function extractHorse(practitioner: CompetitionHorsePractitioner): Array<string> {
        const terms = [practitioner.horse.name]
        if (practitioner.organisation) {
            terms.push(practitioner.organisation.name)
        }
        if (practitioner.presenter) {
            terms.push(practitioner.presenter.name)
        }
        return terms
    }

    function extractTeam(practitioner: CompetitionTeamPractitioner): Array<string> {
        const terms = [practitioner.name]
        if (practitioner.organisation) {
            terms.push(practitioner.organisation.name)
        }
        return terms
    }

    return {
        search
    }
}